// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3ssWX","title":"Info_title__1UjIn","links":"Info_links__1Mke5","link":"Info_link__-p3V_","logo":"Info_logo__1VEia"};